import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _createDeliveryRequest = {
    pickupTime: 'google.protobuf.Timestamp',
    dropoffTime: 'google.protobuf.Timestamp',
    pickupAddress: '_address',
    dropoffAddress: '_address',
};
var _createDeliveryResponse = {
    pickupWindowStartTime: 'google.protobuf.Timestamp',
    pickupWindowEndTime: 'google.protobuf.Timestamp',
    dropoffWindowStartTime: 'google.protobuf.Timestamp',
    dropoffWindowEndTime: 'google.protobuf.Timestamp',
};
var _estimateDeliveryRequest = {
    pickupTime: 'google.protobuf.Timestamp',
    dropoffTime: 'google.protobuf.Timestamp',
    pickupAddress: '_address',
    dropoffAddress: '_address',
};
var _estimateDeliveryResponse = {
    promisedPickupTime: 'google.protobuf.Timestamp',
    promisedDropoffTime: 'google.protobuf.Timestamp',
};
var _getBusinessStatusRequest = {};
var _getBusinessStatusResponse = {};
var _getRegistrationUrlRequest = {};
var _getRegistrationUrlResponse = {};
var _listAccountIdsRequest = {};
var _listAccountIdsResponse = {};
var _listAppDefIdsRequest = {};
var _listAppDefIdsResponse = {};
function resolveComWixpressLocaldeliveryApiV1LocalDeliveryUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/local-delivery/v1',
                destPath: '/v1/local-delivery',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function listAccountIds(payload) {
    var _a = serializer(_listAccountIdsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAccountIdsResponse, {}).fromJSON;
    function __listAccountIds(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.localdelivery.v1.tpa',
            method: 'GET',
            methodFqn: 'com.wixpress.localdelivery.api.v1.LocalDelivery.ListAccountIds',
            url: resolveComWixpressLocaldeliveryApiV1LocalDeliveryUrl({
                protoPath: '/v1/local-delivery/account-ids',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAccountIds.fromReq = fromReq;
    __listAccountIds.__isAmbassador = true;
    return __listAccountIds;
}
export function listAppDefIds(payload) {
    var _a = serializer(_listAppDefIdsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAppDefIdsResponse, {}).fromJSON;
    function __listAppDefIds(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.localdelivery.v1.tpa',
            method: 'GET',
            methodFqn: 'com.wixpress.localdelivery.api.v1.LocalDelivery.ListAppDefIds',
            url: resolveComWixpressLocaldeliveryApiV1LocalDeliveryUrl({
                protoPath: '/v1/local-delivery/app-def-ids',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAppDefIds.fromReq = fromReq;
    __listAppDefIds.__isAmbassador = true;
    return __listAppDefIds;
}
export function getBusinessStatus(payload) {
    var _a = serializer(_getBusinessStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBusinessStatusResponse, {}).fromJSON;
    function __getBusinessStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.localdelivery.v1.tpa',
            method: 'GET',
            methodFqn: 'com.wixpress.localdelivery.api.v1.LocalDelivery.GetBusinessStatus',
            url: resolveComWixpressLocaldeliveryApiV1LocalDeliveryUrl({
                protoPath: '/v1/local-delivery/business-status',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBusinessStatus.fromReq = fromReq;
    __getBusinessStatus.__isAmbassador = true;
    return __getBusinessStatus;
}
export function getRegistrationUrl(payload) {
    var _a = serializer(_getRegistrationUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRegistrationUrlResponse, {}).fromJSON;
    function __getRegistrationUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.localdelivery.v1.tpa',
            method: 'GET',
            methodFqn: 'com.wixpress.localdelivery.api.v1.LocalDelivery.GetRegistrationUrl',
            url: resolveComWixpressLocaldeliveryApiV1LocalDeliveryUrl({
                protoPath: '/v1/local-delivery/registration-url',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRegistrationUrl.fromReq = fromReq;
    __getRegistrationUrl.__isAmbassador = true;
    return __getRegistrationUrl;
}
export function estimateDelivery(payload) {
    var _a = serializer(_estimateDeliveryRequest, { _address: _address, _addressLocation: _addressLocation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_estimateDeliveryResponse, {}).fromJSON;
    function __estimateDelivery(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.localdelivery.v1.tpa',
            method: 'POST',
            methodFqn: 'com.wixpress.localdelivery.api.v1.LocalDelivery.EstimateDelivery',
            url: resolveComWixpressLocaldeliveryApiV1LocalDeliveryUrl({
                protoPath: '/v1/local-delivery/estimate-delivery',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __estimateDelivery.fromReq = fromReq;
    __estimateDelivery.__isAmbassador = true;
    return __estimateDelivery;
}
export function createDelivery(payload) {
    var _a = serializer(_createDeliveryRequest, { _address: _address, _addressLocation: _addressLocation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createDeliveryResponse, {}).fromJSON;
    function __createDelivery(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.localdelivery.v1.tpa',
            method: 'POST',
            methodFqn: 'com.wixpress.localdelivery.api.v1.LocalDelivery.CreateDelivery',
            url: resolveComWixpressLocaldeliveryApiV1LocalDeliveryUrl({
                protoPath: '/v1/local-delivery/create-delivery',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createDelivery.fromReq = fromReq;
    __createDelivery.__isAmbassador = true;
    return __createDelivery;
}
//# sourceMappingURL=http.impl.js.map